interface ChipWarningSelectionScope {
  selectedSamples: string[] | null;
  selectedGroups: string[] | null;
}

interface ChipWarningNextSelection {
  samples: string[] | null;
  groups: string[] | null;
}

export function getChipWarningAssayFocusSelection(
  scope: ChipWarningSelectionScope,
  assay: string,
): ChipWarningNextSelection {
  return scope.selectedSamples == null && hasExactSelection(scope.selectedGroups, [assay])
    ? { samples: null, groups: null }
    : { samples: null, groups: [assay] };
}

export function getChipWarningSampleFocusSelection(
  scope: ChipWarningSelectionScope,
  samples: string[],
): ChipWarningNextSelection {
  return scope.selectedGroups == null && hasExactSelection(scope.selectedSamples, samples)
    ? { samples: null, groups: null }
    : { samples, groups: null };
}

export function getChipWarningSampleAssayFocusSelection(
  scope: ChipWarningSelectionScope,
  samples: string[],
  assay: string,
): ChipWarningNextSelection {
  return hasExactSelection(scope.selectedSamples, samples) && hasExactSelection(scope.selectedGroups, [assay])
    ? { samples: null, groups: null }
    : { samples, groups: [assay] };
}

function hasExactSelection(currentSelection: string[] | null, targetSelection: string[]): boolean {
  return (
    currentSelection != null &&
    currentSelection.length === targetSelection.length &&
    targetSelection.every(target => currentSelection.includes(target))
  );
}
